import { render, staticRenderFns } from "./VoiceCommands.vue?vue&type=template&id=7c2b17da&scoped=true&"
import script from "./VoiceCommands.vue?vue&type=script&lang=js&"
export * from "./VoiceCommands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b17da",
  null
  
)

export default component.exports